import { render, staticRenderFns } from "./flexipassDoors.vue?vue&type=template&id=2c8aa5e4&scoped=true&"
import script from "./flexipassDoors.vue?vue&type=script&lang=js&"
export * from "./flexipassDoors.vue?vue&type=script&lang=js&"
import style0 from "./flexipassDoors.vue?vue&type=style&index=0&id=2c8aa5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8aa5e4",
  null
  
)

export default component.exports